const fr: Record<string, string> = {
  'guitarSong.list.add': 'Ajouter un morceau',
  'guitarSong.list.loadError': 'Impossible de charger le répertoire.',
  'guitarSong.list.searchPlaceholder': 'Rechercher titre, auteur, paroles…',
  'guitarSong.list.noResults': 'Aucun morceau ne correspond à votre recherche ou vos filtres.',
  'guitarSong.list.clearFilters': 'Effacer les filtres',
  'guitarSong.card.tempo': '{{bpm}} BPM · {{beats}} temps/mesure',
  'guitarSong.card.capo': 'Capo {{fret}}',
  'guitarSong.card.chordCount': '{{count}} accords',
  'guitarSong.card.difficultChordCount': '{{count}} difficiles',
  'guitarSong.state.draft': 'Brouillon',
  'guitarSong.state.completed': 'Terminé',
  'guitarSong.difficulty.label': 'Difficulté',
  'guitarSong.difficulty.level0': 'Très facile',
  'guitarSong.difficulty.level1': 'Facile',
  'guitarSong.difficulty.level2': 'Modéré',
  'guitarSong.difficulty.level3': 'Intermédiaire',
  'guitarSong.difficulty.level4': 'Difficile',
  'guitarSong.difficulty.level5': 'Très difficile',
  'guitarSong.mastery.label': 'Ma maîtrise',
  'guitarSong.mastery.level0': 'Inconnu',
  'guitarSong.mastery.level1': 'Débuté',
  'guitarSong.mastery.level2': 'En apprentissage',
  'guitarSong.mastery.level3': 'En progrès',
  'guitarSong.mastery.level4': 'Confiant',
  'guitarSong.mastery.level5': 'Parfaitement acquis',
  'guitarSong.form.title': 'Titre',
  'guitarSong.form.author': 'Auteur',
  'guitarSong.form.authorPlaceholder': 'Choisir un auteur',
  'guitarSong.form.addNewAuthor': '+ Ajouter un nouvel auteur…',
  'guitarSong.form.newAuthorPlaceholder': "Nom du nouvel auteur",
  'guitarSong.form.copyFromSong': 'Copier depuis un morceau',
  'guitarSong.form.copyFromSongHelp': "Reprend tout d'un autre morceau — accords, paroles, vidéos, labels et mise en page — vous pouvez toujours changer le titre et l'auteur ci-dessus.",
  'guitarSong.form.copyFromSongPlaceholder': 'Aucune copie',
  'guitarSong.form.template': 'Modèle de mise en page',
  'guitarSong.form.templateHelp': "Partir de la mise en page d'un autre morceau plutôt que celle par défaut.",
  'guitarSong.form.templatePlaceholder': 'Mise en page par défaut',
  'guitarSong.form.blankLayout': 'Partir d\'une page blanche',
  'guitarSong.form.blankLayoutHelp': 'Aucune ligne n\'est ajoutée automatiquement — construisez la page vous-même, ligne/colonne/élément par élément.',
  'guitarSong.form.contentType': 'Contenu',
  'guitarSong.form.contentTypeLayout': 'Mise en page libre',
  'guitarSong.form.contentTypePdf': 'PDF importé',
  'guitarSong.form.contentTypeHelp': 'Choisissez comment fonctionne le contenu de ce morceau — ce choix ne peut plus être changé ensuite.',
  'guitarSong.form.pdfFile': 'Fichier PDF',
  'guitarSong.form.pdfFileHelp': 'Importez une feuille PDF au lieu de construire une mise en page.',
  'guitarSong.form.pdfFileButton': 'Choisir un fichier PDF',
  'guitarSong.form.pdfFileUploadError': 'Impossible d\'envoyer le fichier. Veuillez réessayer.',
  'guitarSong.form.labels': 'Labels',
  'guitarSong.form.addTitle': 'Ajouter un morceau',
  'guitarSong.form.diagramStyle': 'Style des diagrammes d\'accords',
  'guitarSong.form.diagramStyleFull': 'Complet (intervalles étiquetés)',
  'guitarSong.form.diagramStyleSimple': 'Simple (points uniquement)',
  'guitarSong.form.diagramStyleFullShort': 'Complet',
  'guitarSong.form.diagramStyleSimpleShort': 'Simple',
  'guitarSong.form.diagramSize': 'Taille des diagrammes d\'accords',
  'guitarSong.form.diagramSizeXxs': 'XXS',
  'guitarSong.form.diagramSizeXs': 'XS',
  'guitarSong.form.diagramSizeS': 'S',
  'guitarSong.form.diagramSizeM': 'M',
  'guitarSong.form.diagramSizeL': 'L',
  'guitarSong.form.diagramSizeXl': 'XL',
  'guitarSong.form.diagramSizeXxl': 'XXL',
  'guitarSong.form.lyricsLineSpacing': 'Espace entre les lignes (px)',
  'guitarSong.form.lyricsTextSize': 'Taille du texte (px)',
  'guitarSong.form.lyricsChordSize': 'Taille des accords (px)',
  'guitarSong.detail.loadError': 'Impossible de charger le morceau.',
  'guitarSong.detail.statBpm': 'BPM',
  'guitarSong.detail.statBeatsPerBar': 'Temps/mesure',
  'guitarSong.detail.statCapo': 'Capo',
  'guitarSong.detail.chords': 'Accords',
  'guitarSong.detail.chordGrid': 'Tableau d\'accords',
  'guitarSong.detail.addChord': 'Ajouter un accord',
  'guitarSong.detail.removeChord': 'Retirer du morceau',
  'guitarSong.detail.removeChordConfirm': 'Retirer {{name}} de ce morceau ? Il restera dans l\'inventaire partagé.',
  'guitarSong.detail.moveUp': 'Monter',
  'guitarSong.detail.moveDown': 'Descendre',
  'guitarSong.detail.comment': 'Commentaire',
  'guitarSong.detail.commentPlaceholder': 'ex : jouer doucement, gratté étouffé…',
  'guitarSong.detail.archive': 'Archiver le morceau',
  'guitarSong.detail.archiveTitle': 'Archiver le morceau',
  'guitarSong.detail.archiveMessage': 'Archiver « {{title}} » ? Il n\'apparaîtra plus dans le répertoire.',
  'guitarSong.detail.markCompleted': 'Marquer comme terminé',
  'guitarSong.detail.backToDraft': 'Repasser en brouillon',
  'guitarSong.detail.backToList': 'Retour au répertoire',
  'guitarSong.picker.title': 'Ajouter un accord à ce morceau',
  'guitarSong.picker.add': 'Ajouter au morceau',
  'guitarSong.sections.blockOption': 'Paroles & Accords n°{{index}}',
  'guitarSong.sections.setupConfirm': 'Démarrer ce bloc',
  'guitarSong.sections.linkToExisting': 'Lier à un bloc existant',
  'guitarSong.sections.linkToExistingNone': 'Aucune — nouveau contenu',
  'guitarSong.sections.linkedContentNote': 'Reflète le bloc lié',
  'guitarSong.sections.linkedTo': 'Lié à',
  'guitarSong.sections.lyricsPlaceholder': 'Tapez les paroles de ce bloc…',
  'guitarSong.sections.attachChords': 'Attacher des accords',
  'guitarSong.sections.hideAttachChords': 'Terminer l\'attache des accords',
  'guitarSong.sections.noChord': 'Aucun accord',
  'guitarSong.sections.emptySlotLabel': '(espace)',
  'guitarSong.sections.positionBefore': 'Avant',
  'guitarSong.sections.positionStart': 'Début',
  'guitarSong.sections.positionMiddle': 'Milieu',
  'guitarSong.sections.positionEnd': 'Fin',
  'guitarSong.sections.positionAfter': 'Après',
  'guitarSong.sections.previousPosition': 'Position précédente',
  'guitarSong.sections.nextPosition': 'Position suivante',
  'guitarSong.sections.previousWord': 'Mot précédent',
  'guitarSong.sections.nextWord': 'Mot suivant',
  'guitarSong.chordGrid.editCell': 'Modifier la cellule',
  'guitarSong.chordGrid.chordSize': 'Taille du texte des accords',
  'guitarSong.chordGrid.borderTop': 'Haut',
  'guitarSong.chordGrid.borderRight': 'Droite',
  'guitarSong.chordGrid.borderBottom': 'Bas',
  'guitarSong.chordGrid.borderLeft': 'Gauche',
  'guitarSong.chordGrid.moveItemLeft': 'Déplacer à gauche',
  'guitarSong.chordGrid.moveItemRight': 'Déplacer à droite',
  'guitarSong.chordGrid.removeItem': 'Retirer',
  'guitarSong.chordGrid.addTextPlaceholder': 'Ajouter du texte (ex : x4)',
  'guitarSong.chordGrid.addText': 'Ajouter le texte',
  'guitarSong.chordGrid.needsChordsBlock': 'Ajoutez d\'abord un bloc Accords à la page pour pouvoir ajouter des accords ici.',
  'guitarSong.chordGrid.addRowBefore': 'Insérer une ligne avant',
  'guitarSong.chordGrid.addRowAfter': 'Insérer une ligne après',
  'guitarSong.chordGrid.removeRow': 'Retirer la ligne',
  'guitarSong.chordGrid.addColumnBefore': 'Insérer une colonne avant',
  'guitarSong.chordGrid.addColumnAfter': 'Insérer une colonne après',
  'guitarSong.chordGrid.removeColumn': 'Retirer la colonne',
  'guitarSong.videos.title': 'Vidéos',
  'guitarSong.videos.add': 'Ajouter une vidéo',
  'guitarSong.videos.remove': 'Retirer la vidéo',
  'guitarSong.videos.titlePlaceholder': 'Titre (optionnel)',
  'guitarSong.videos.urlLabel': 'URL de la vidéo',
  'guitarSong.learningTools.title': "Outils d'apprentissage",
  'guitarSong.labels.newLabelPlaceholder': 'Nom du nouveau label',
  'guitarSong.labels.createLabel': 'Créer le label',
  'guitarSong.labels.manageLabels': 'Gérer les labels',
  'guitarSong.labels.moveLeft': 'Déplacer le label plus tôt',
  'guitarSong.labels.moveRight': 'Déplacer le label plus tard',
  'guitarSong.layout.presentationMode': 'Vue présentation',
  'guitarSong.layout.backToSong': 'Retour à l\'édition',
  'guitarSong.layout.downloadPdf': 'Télécharger le PDF',
  'guitarSong.pdf.openInNewTab': 'Ouvrir dans un nouvel onglet',
  'guitarSong.pdf.replaceButton': 'Remplacer le PDF',
  'guitarSong.pdf.replaceHelp': 'Importer un nouveau fichier remplace l\'actuel.',
  'guitarSong.layout.pageSettingsLabel': 'Mise en page',
  'guitarSong.layout.pageSizeLabel': 'Taille de la page',
  'guitarSong.layout.showStructureOutlines': 'Afficher les contours des lignes/colonnes/blocs',
  'guitarSong.layout.hideStructureOutlines': 'Masquer les contours des lignes/colonnes/blocs',
  'guitarSong.layout.pageSizeA4': 'A4 (comme le PDF)',
  'guitarSong.layout.pageSizeA4Caption': 'A4 ({{width}} mm)',
  'guitarSong.layout.pageSizeLetter': 'US Letter',
  'guitarSong.layout.pageSizeLetterCaption': 'Letter ({{width}} mm)',
  'guitarSong.layout.pageSizeFull': 'Pleine largeur',
  'guitarSong.layout.pageSizeCustom': 'Personnalisé',
  'guitarSong.layout.pageSizeCustomWidthLabel': 'Largeur (mm)',
  'guitarSong.layout.openMarginsMenu': 'Marges de la page',
  'guitarSong.layout.marginTop': 'Haut (mm)',
  'guitarSong.layout.marginRight': 'Droite (mm)',
  'guitarSong.layout.marginBottom': 'Bas (mm)',
  'guitarSong.layout.marginLeft': 'Gauche (mm)',
  'guitarSong.layout.footerSpacing': 'Espacement du pied de page (mm)',
  'guitarSong.layout.rowMenu': 'Options de la ligne',
  'guitarSong.layout.columnMenu': 'Options de la colonne',
  'guitarSong.layout.blockMenu': 'Options du bloc',
  'guitarSong.layout.editBlock': 'Modifier',
  'guitarSong.layout.copyBlock': 'Copier',
  'guitarSong.layout.addBlockAfter': 'Ajouter un bloc après',
  'guitarSong.layout.addEmptyBlockOption': 'Bloc vide',
  'guitarSong.layout.pasteBlock': 'Coller',
  'guitarSong.layout.previewClipboard': 'Voir ce qui est copié',
  'guitarSong.layout.pasteOtherSong': 'Copié depuis un autre morceau',
  'guitarSong.layout.clipboardUnavailable': 'Ce contenu copié n\'est plus disponible.',
  'guitarSong.layout.blockContentTab': 'Contenu',
  'guitarSong.layout.blockTitleTab': 'Titre',
  'guitarSong.layout.blockSharedTab': 'Partagé',
  'guitarSong.layout.blockPresentationTab': 'Présentation',
  'guitarSong.layout.emptyBlock': '{{type}} vide — cliquez sur Modifier pour le remplir',
  'guitarSong.layout.addRow': 'Ajouter une ligne',
  'guitarSong.layout.insertRowHere': 'Insérer une ligne ici',
  'guitarSong.layout.pageBreakBefore': 'Commencer une nouvelle page avant cette ligne',
  'guitarSong.layout.removeRow': 'Retirer la ligne',
  'guitarSong.layout.removeRowConfirm': 'Retirer cette ligne et tout ce qu’elle contient ? Cette action est irréversible.',
  'guitarSong.layout.removeColumn': 'Retirer la colonne',
  'guitarSong.layout.columnPresentation': 'Présentation',
  'guitarSong.layout.addToThisColumn': 'Ajouter à cette colonne',
  'guitarSong.layout.addNewColumn': 'Ajouter une nouvelle colonne',
  'guitarSong.layout.addElementPlaceholder': 'Élément',
  'guitarSong.layout.addElementConfirm': 'Ajouter',
  'guitarSong.layout.addCustomBlock': '+ Texte libre',
  'guitarSong.layout.removeBlock': 'Retirer le bloc',
  'guitarSong.layout.removeBlockConfirm': 'Retirer ce bloc ? Cette action est irréversible.',
  'guitarSong.layout.removeBlockTitle': 'Retirer le titre',
  'guitarSong.layout.blockTitlePlaceholder': 'Titre de la section principale',
  'guitarSong.layout.customBlockTitle': 'Titre de la section principale',
  'guitarSong.layout.customBlockContentSize': 'Taille du texte',
  'guitarSong.layout.customBlockWidth': 'Largeur (1-{{max}})',
  'guitarSong.layout.blockZoom': 'Zoom % (30-200)',
  'guitarSong.layout.titleHeadingLevel': 'Taille du titre',
  'guitarSong.layout.blockShowCard': 'Afficher en carte',
  'guitarSong.layout.customBlocksTitle': 'Blocs personnalisés',
  'guitarSong.layout.widthNarrower': 'Plus étroite',
  'guitarSong.layout.widthWider': 'Plus large',
  'guitarSong.layout.noRoomForNewColumn': 'Plus de place sur cette ligne — réduisez d\'abord une colonne',
  'guitarSong.layout.moveColumnLeft': 'Déplacer la colonne à gauche',
  'guitarSong.layout.moveColumnRight': 'Déplacer la colonne à droite',
  'guitarSong.layout.moveBlockLeft': 'Déplacer l\'élément à gauche',
  'guitarSong.layout.moveBlockRight': 'Déplacer l\'élément à droite',
  'guitarSong.layout.addEmptyColumn': 'Colonne vide (pour l\'espacement)',
  'guitarSong.layout.pasteToNewColumn': 'Coller dans une nouvelle colonne',
  'guitarSong.layout.addEmptyRow': 'Ligne vide (pour l\'espacement)',
  'guitarSong.layout.alignLeft': 'Gauche',
  'guitarSong.layout.alignCenter': 'Centre',
  'guitarSong.layout.alignRight': 'Droite',
  'guitarSong.layout.paddingTop': 'Marge int. haut (mm)',
  'guitarSong.layout.paddingRight': 'Marge int. droite (mm)',
  'guitarSong.layout.paddingBottom': 'Marge int. bas (mm)',
  'guitarSong.layout.paddingLeft': 'Marge int. gauche (mm)',
  'guitarSong.layout.paddingTopShort': 'Haut',
  'guitarSong.layout.paddingRightShort': 'Droite',
  'guitarSong.layout.paddingBottomShort': 'Bas',
  'guitarSong.layout.paddingLeftShort': 'Gauche',
  'guitarSong.layout.columnMarginsTitle': 'Marges',
  'guitarSong.layout.blockMarginsTitle': 'Marges',
  'guitarSong.layout.separatorLeft': 'Séparation gauche de la colonne',
  'guitarSong.layout.separatorRight': 'Séparation droite de la colonne',
  'guitarSong.layout.block.title': 'Titre',
  'guitarSong.layout.block.author': 'Auteur',
  'guitarSong.layout.block.tempo': 'Tempo (BPM)',
  'guitarSong.layout.block.time_signature': 'Signature rythmique',
  'guitarSong.layout.block.capo': 'Capo',
  'guitarSong.layout.block.description': 'Description',
  'guitarSong.layout.block.chords': 'Catalogue d\'accords',
  'guitarSong.layout.block.sections': 'Parties et paroles',
  'guitarSong.layout.block.labels': 'Labels',
  'guitarSong.layout.block.chord_grid': 'Grille d\'accords',
  'guitarSong.layout.block.custom': 'Texte libre',
};

export default fr;
